import {Action} from '@ngrx/store';
import {GetRsvpQuestionsSuccessAction} from '../actions/rsvp-questions/get-rsvp-questions-success-action';
import {RsvpQuestionsState} from '../states/rsvp-questions-state';
import {GetRsvpQuestionsAction} from '../actions/rsvp-questions/get-rsvp-questions-action';
import {GetRsvpQuestionsErrorAction} from '../actions/rsvp-questions/get-rsvp-questions-error-action';
import {Deserialize, Serialize} from 'cerialize';

const initialState = new RsvpQuestionsState();

export function RsvpQuestionsReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: RsvpQuestionsState = Deserialize(serializedState);

  switch (action.type) {
    case GetRsvpQuestionsAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetRsvpQuestionsSuccessAction.type:
      state.ready = true;
      state.rsvpQuestions = (<GetRsvpQuestionsSuccessAction>action).rsvpQuestions;
      state.error = null;
      break;

    case GetRsvpQuestionsErrorAction.type:
      state.ready = true;
      state.error = (<GetRsvpQuestionsErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
